/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';

/**
 * Short transfers from golden project
 */
export interface GoldenTransferShortDto {
  id: number;
  asset: string;
  network: string;
  contract: string;
  fromAddress: string;
  fromLabel?: string;
  toAddress: string;
  toLabel?: string;
  txHash: string;
  quantity: number;
  time: string;
  status: GoldenTransferShortDto.StatusEnum;
  comment: string;
  direction: GoldenTransferShortDto.DirectionEnum;
  account?: Account;
  requestAdminId?: number;
  approveAdminId?: number;
  resolveComment: string;
}
export namespace GoldenTransferShortDto {
  export const StatusEnum = {
    Pending: 'PENDING',
    Error: 'ERROR',
    Settled: 'SETTLED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
  export const DirectionEnum = {
    Deposit: 'DEPOSIT',
    Withdraw: 'WITHDRAW',
    Internal: 'INTERNAL',
    DepositRebate: 'DEPOSIT_REBATE',
    WithdrawRebate: 'WITHDRAW_REBATE',
    InternalDeposit: 'INTERNAL_DEPOSIT',
    InternalWithdraw: 'INTERNAL_WITHDRAW',
  } as const;
  export type DirectionEnum = (typeof DirectionEnum)[keyof typeof DirectionEnum];
}
